import axios, { AxiosInstance } from "axios";
import { API_BASE_URL } from "@/config/apiBase";

function createAxiosInstance(token?: string): AxiosInstance {
  const instance = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });

  return instance;
}

export default createAxiosInstance;
